import React from 'react';
import ProtectedRoutes from 'components/RouteProtection';
import { useLocation } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';
import { SPARK_RUN_ROUTE_REGEX } from 'constants/regex';

type AuthWrapperTypes = {
  children: React.ReactNode;
};
const UNPROTECTED_ROUTES: string[] = [
  SPARK_ROUTES.AUTH_CALLBACK,
  SPARK_ROUTES.LOGIN,
  SPARK_ROUTES.REGISTER,
  SPARK_ROUTES.FORGOT_PASSWORD,
  SPARK_ROUTES.RESET_PASSWORD,
  SPARK_ROUTES.MEMORIES,
];

function AuthWrapper({ children }: AuthWrapperTypes) {
  const location = useLocation();
  const path = location.pathname.split('/')[1];
  const route = `/${path}`;

  const isUnProtectedRoute = UNPROTECTED_ROUTES.includes(route);
  const isUnprotectedSparkRun = SPARK_RUN_ROUTE_REGEX.test(location.pathname);

  const isUnProtected = isUnProtectedRoute || isUnprotectedSparkRun;

  return (
    <>
      {!isUnProtected ? (
        <ProtectedRoutes>{children}</ProtectedRoutes>
      ) : (
        children
      )}
    </>
  );
}

export default AuthWrapper;
